import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  trans_date: z.string().optional()
})

export const ListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `/`,
    component: lazyRouteComponent(() => import('./List')),
    validateSearch: (search) => searchSchema.parse(search)
  })
